import { resetPasswordStyles } from "@insite/content-library/Widgets/ResetPassword/ResetPassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

resetPasswordStyles.instructionsText = {
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.title} !important;
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.base} !important;
        font-size: ${TYPOGRAPHY.size.smaller} !important;
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getColor("text.accent")} !important;
        padding-bottom: 8px;
    `,
};

resetPasswordStyles.newPasswordGridItem = {
    css: css`
        flex-basis: 100%;
        max-width: 100%;
        > div[class^="FormFieldStyle"] {
            > label {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                line-height: ${TYPOGRAPHY.lineHeight.base};
                color: ${getColor("text.main")} !important;
            }
            > input {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base} !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                color: ${getColor("text.accent")} !important;
            }
        }
    `,
};

resetPasswordStyles.confirmNewPasswordGridItem = {
    css: css`
        flex-basis: 100%;
        max-width: 100%;
        > div[class^="FormFieldStyle"] {
            > label {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
                line-height: ${TYPOGRAPHY.lineHeight.base};
                color: ${getColor("text.main")} !important;
            }
            > input {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base} !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                color: ${getColor("text.accent")} !important;
            }
        }
    `,
};
resetPasswordStyles.passwordGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-left: 17px;
                        //margin: 15px !important;
                    `,
                ],
                "min",
            )}
    `,
};
resetPasswordStyles.passwordGridContainer = {
    css: css`
        margin: initial;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        max-width: 300px;
                    `,
                ],
                "min",
            )};
    `,
};
resetPasswordStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};
